import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormContentSizeButtonMainStyled} from "../styled";
import {Button} from "@material-ui/core";
import ModalComponent from "../../../../Components/Modal/ModalComponent";
import ModalConfirmationComponent from "./ModalConfirmationComponent";

class FooterMensageriaComponent extends Component {
    render() {
        const {
            isOpen,
            form,
            selectedClients,
            sendToAll,
            pagination,
            onReviewAndSend,
            onBack,
            onConfirm,
        } = this.props;

        const recipientsCount = sendToAll
            ? (pagination?.total || 0)
            : (selectedClients?.length || 0);

        return (
            <>
                <FormContentSizeButtonMainStyled>
                    <Button variant={'contained'}
                            color={'primary'}
                            size={"large"}
                            fullWidth={true}
                            onClick={() => onReviewAndSend && onReviewAndSend()}>
                        Revisar e Enviar
                    </Button>
                </FormContentSizeButtonMainStyled>
                <ModalComponent isOpen={isOpen}
                                title={'Confirmar envio'}>
                    <ModalConfirmationComponent
                        recipientsCount={recipientsCount}
                        pushRecipientsCount={recipientsCount}
                        costPerSend={'Grátis'}
                        appInitial={'M'}
                        notificationTitle={form?.subject || ''}
                        notificationBody={form?.body || ''}
                        onBack={onBack}
                        onConfirm={onConfirm}
                    />
                </ModalComponent>
            </>
        );
    }
}

FooterMensageriaComponent.propTypes = {
    isOpen: PropTypes.bool,
    form: PropTypes.object,
    selectedClients: PropTypes.array,
    sendToAll: PropTypes.bool,
    pagination: PropTypes.object,
    onReviewAndSend: PropTypes.func,
    onBack: PropTypes.func,
    onConfirm: PropTypes.func,
};

FooterMensageriaComponent.defaultProps = {
    isOpen: false,
    form: {
        subject: '',
        body: '',
    },
    selectedClients: [],
    sendToAll: false,
    pagination: null,
    onReviewAndSend: () => {},
    onBack: () => {},
    onConfirm: () => {},
};

export default FooterMensageriaComponent;